import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import App from './App'
import Error from './404'
import Index from './pages/Index'
import React from 'react'

function Routes() {
  return (
    <Router>
      <App>
        <Switch>
          <Redirect from="/" to="/index/dashboard" exact />
          <Redirect from="/index" to="/index/dashboard" exact />
          <Route path="/index/:activeKey" component={Index} />
          <Route component={Error} />
        </Switch>
      </App>
    </Router>
  )
}

export default Routes
